function xmur3(value) {
  let hash = 1779033703 ^ value.length;
  for (let index = 0; index < value.length; index += 1) {
    hash = Math.imul(hash ^ value.charCodeAt(index), 3432918353);
    hash = (hash << 13) | (hash >>> 19);
  }
  return () => {
    hash = Math.imul(hash ^ (hash >>> 16), 2246822507);
    hash = Math.imul(hash ^ (hash >>> 13), 3266489909);
    return (hash ^= hash >>> 16) >>> 0;
  };
}

function mulberry32(seed) {
  return () => {
    let value = (seed += 0x6d2b79f5);
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
}

function shuffle(items, random) {
  const result = [...items];
  for (let index = result.length - 1; index > 0; index -= 1) {
    const target = Math.floor(random() * (index + 1));
    [result[index], result[target]] = [result[target], result[index]];
  }
  return result;
}

function weightedTargetCount(weights, random) {
  const entries = Object.entries(weights || {})
    .map(([count, weight]) => [Number(count), Number(weight)])
    .filter(([count, weight]) => Number.isInteger(count) && count > 0 && weight > 0)
    .sort((left, right) => left[0] - right[0]);
  const total = entries.reduce((sum, [, weight]) => sum + weight, 0);
  if (!total) throw new Error('Refleks hedef dağılımı geçerli değil.');
  let cursor = random() * total;
  for (const [count, weight] of entries) {
    cursor -= weight;
    if (cursor < 0) return count;
  }
  return entries[entries.length - 1][0];
}

function pickAsset(assets, random) {
  if (!assets?.length) throw new Error('Refleks karakter kataloğu boş.');
  return assets[Math.floor(random() * assets.length)];
}

export function buildReflexWave(config, waveIndex, catalog) {
  const random = mulberry32(xmur3(`${config.seed}:wave:${waveIndex}`)());
  const holeCount = Number(config.grid_rows) * Number(config.grid_columns);
  const targetCount = weightedTargetCount(config.target_count_weights, random);
  if (!Number.isInteger(holeCount) || holeCount < targetCount + 1) {
    throw new Error('Refleks grid konfigürasyonu geçerli değil.');
  }

  const holes = shuffle(Array.from({ length: holeCount }, (_, index) => index), random);
  const targets = holes.slice(0, targetCount).map((holeIndex) => {
    const asset = pickAsset(catalog.targets, random);
    return { holeIndex, assetId: asset.id, label: asset.label, symbol: asset.symbol };
  });
  const distractorRoll = random() * 100;
  const hasDistractor = distractorRoll < Number(config.distractor_probability_pct || 0);
  const distractor = hasDistractor
    ? (() => {
      const asset = pickAsset(catalog.distractors, random);
      return {
        holeIndex: holes[targetCount],
        assetId: asset.id,
        label: asset.label,
        symbol: asset.symbol,
      };
    })()
    : null;
  const gapRange = Math.max(0, Number(config.gap_max_ms) - Number(config.gap_min_ms));
  const gapMs = Number(config.gap_min_ms) + Math.floor(random() * (gapRange + 1));
  return { waveIndex, targets, distractor, gapMs };
}

